export default (state, onlyGlobal) => {
  state.onlyGlobal = onlyGlobal;
}



// WEBPACK FOOTER //
// ./src/app/store/templates/main/mutations/set-only-global.js